const {GeoJSON2SVG} = require('./src/index.js');
module.exports = GeoJSON2SVG;
